import { CheckCircleOutlineOutlined, ErrorOutline } from "@mui/icons-material";
import { Box, Tooltip, Typography } from "@mui/material";
import React from "react";
import { useStyles } from "./styles";

const RowDetails = ({ data }) => {
  const classes = useStyles();

  return (
    <Box className={classes.rowDetails}>
      <Typography gutterBottom={true} variant="subtitle2">
        Subasks
      </Typography>
      <table>
        <thead>
          <tr>
            <th>First Name </th>
            <th>Last Name</th>
            <th>Email</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {data?.tasks?.map((task) => (
            <tr key={task?.email}>
              <td>{task?.firstName}</td>
              <td>{task?.lastName}</td>
              <td>{task?.email}</td>
              <td>
                {task?.success === undefined ? (
                  "-"
                ) : (
                  <Tooltip placement="top" title={task?.message}>
                    {task.success ? (
                      <CheckCircleOutlineOutlined
                        sx={{ color: (theme) => theme.palette.success.main }}
                      />
                    ) : (
                      <ErrorOutline
                        sx={{ color: (theme) => theme.palette.error.main }}
                      />
                    )}
                  </Tooltip>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  );
};

export default RowDetails;
